import {Util} from 'bootstrap';
const Open = (($)=>{
    const EVENT = {
        SHOW: 'show.iv.open',
        HIDE: 'hide.iv.open',
    };
    const CLASS = {
        SHOW: 'show',
        HOVER_MOUSE_ENTER: 'open-mouseenter',
    };
    const SELECTOR = {
        DATA_TOGGLE: '[data-toggle="open"]',
        DATA_TOGGLE_HOVER: '[data-toggle="open-hover"]',
    };
    const CONFIG = {
        HOVER_DELAY: 500,
    };
    class Open {
        static open(target) {
            $(Util.getSelectorFromElement(target)).addClass(CLASS.SHOW).trigger(new $.Event(EVENT.SHOW));
        }
        static close(target) {
            $(Util.getSelectorFromElement(target)).removeClass(CLASS.SHOW).trigger(new $.Event(EVENT.HIDE));
        }
        static show(event) {
            Open.open(event.currentTarget);
            event.preventDefault();
        }
        static hide(event) {
            Open.close(event.currentTarget);
            event.preventDefault();
        }
        static toggle(event) {
            if ($(Util.getSelectorFromElement(event.currentTarget)).hasClass(CLASS.SHOW)) {
                Open.close(event.currentTarget);
            } else {
                Open.open(event.currentTarget);
            }
            event.preventDefault();
        }

        static toggleHover(event) {
            const element = $(this);
            const target = $(element.data('target'));
            const eventTarget = event.currentTarget;
            element.off('mouseleave');
            target.off('mouseenter mouseleave');

            if (!element.hasClass(CLASS.HOVER_MOUSE_ENTER)) {
                element.addClass(CLASS.HOVER_MOUSE_ENTER);
                Open.open(eventTarget);
            }

            element.on('mouseleave', function(event) {
                element.removeClass(CLASS.HOVER_MOUSE_ENTER);
                Open.launchHoverTimeout(element, eventTarget);
            });

            target.on('mouseenter mouseleave', function(event) {
                switch (event.handleObj.origType) {
                    case 'mouseenter':
                        target.addClass(CLASS.HOVER_MOUSE_ENTER);
                    break;
                    case 'mouseleave':
                        target.removeClass(CLASS.HOVER_MOUSE_ENTER);
                        Open.launchHoverTimeout(element, eventTarget);
                    break;
                }
            });
        }

        static launchHoverTimeout(element, currentTarget) {
            let delay = element.data('delay') ? parseInt(element.data('delay')) : CONFIG.HOVER_DELAY;
            const target = $(element.data('target'));
            setTimeout(function() {
                if (!element.hasClass(CLASS.HOVER_MOUSE_ENTER) && !target.hasClass(CLASS.HOVER_MOUSE_ENTER)) {
                    Open.close(currentTarget);
                }
            }, delay);
        }
    }
    $(document)
        .on('click', SELECTOR.DATA_TOGGLE, Open.toggle)
        .on('mouseenter', SELECTOR.DATA_TOGGLE_HOVER, Open.toggleHover);
    return Open;
})($);

// Экспорт;
window.Block = window.Block ? window.Block : {};
window.Block.Open = Open;
export default Open;
